<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import NucleoWorkOrdersDesktopTable from './NucleoWorkOrdersDesktopTable.vue';
import NucleoWorkOrdersMobileList from './NucleoWorkOrdersMobileList.vue';

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  page: { type: Number, default: 1 },
  totalPages: { type: Number, default: 0 },
  totalRows: { type: Number, default: 0 },
});

const emit = defineEmits(['changePage', 'open']);
const { t } = useI18n();
</script>

<template>
  <section
    class="overflow-hidden rounded-lais border border-lais-border-soft bg-white shadow-lais-card"
  >
    <div v-if="loading" class="space-y-3 p-5">
      <div
        v-for="index in 5"
        :key="index"
        class="h-14 animate-pulse rounded-lais bg-lais-bg-soft"
      />
    </div>
    <div
      v-else-if="!rows.length"
      class="p-10 text-center text-sm text-lais-text-muted"
    >
      {{ t('NUCLEO_WORK_ORDERS.TABLE.EMPTY') }}
    </div>
    <template v-else>
      <NucleoWorkOrdersDesktopTable :rows="rows" @open="emit('open', $event)" />
      <NucleoWorkOrdersMobileList :rows="rows" @open="emit('open', $event)" />
    </template>
    <footer
      class="flex flex-wrap items-center justify-between gap-3 border-t border-lais-border-soft px-4 py-3 text-sm text-lais-text-muted"
    >
      <span>{{
        t('NUCLEO_WORK_ORDERS.TABLE.SHOWING', {
          count: rows.length,
          total: totalRows,
        })
      }}</span>
      <div class="flex items-center gap-2">
        <span>{{
          t('NUCLEO_WORK_ORDERS.TABLE.PAGE', { page, total: totalPages || 1 })
        }}</span>
        <LaisPrimaryButton
          variant="ghost"
          size="sm"
          :disabled="page <= 1"
          @click="emit('changePage', page - 1)"
        >
          {{ t('NUCLEO_WORK_ORDERS.ACTIONS.PREVIOUS') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          variant="ghost"
          size="sm"
          :disabled="page >= totalPages || !totalPages"
          @click="emit('changePage', page + 1)"
        >
          {{ t('NUCLEO_WORK_ORDERS.ACTIONS.NEXT') }}
        </LaisPrimaryButton>
      </div>
    </footer>
  </section>
</template>
